<template>
	<div class="pt-5" v-title :data-title="orderDetail.isPay?'支付成功':'支付失败'">
		<div class="paysuccess banpage">
		 	<div class="fl paysuccess_con">
		 		<div class="list1 "><i :class="orderDetail.isPay?'el-icon-circle-check':'el-icon-circle-close'"></i><span class="ml-1">支付{{ orderDetail.isPay?"成功":"失败" }}</span></div>
		 		<strong class="list2 db ">￥{{orderDetail.price}}</strong>
		 		<span class="returnindex cur-pointer" @click="routerself('/researchIndex') ">返回首页</span>
		 		<p class="list3"><span class="db">订单{{orderDetail.status}}成功</span><span class="db">服务热线：400-008-1522 &nbsp;&nbsp;  0755-82571522</span></p>
		 	</div>
		 	<ul class="fr order_infor">
		 		<li><strong class="title fl">订单编号</strong><span class="fl">{{orderDetail.id}}</span></li>
		 		<li><strong class="title fl">订单内容</strong><span class="fl"><em>产业研究大脑 - {{orderDetail.title}}</em><em>{{orderDetail.years}}年使用时长</em></span></li>
		 		<li><strong class="title fl">联系手机</strong><span class="fl">{{orderDetail.mobile}}</span></li>
		 		<li><strong class="title fl">订单金额</strong><span class="fl"><b>¥{{orderDetail.price}}</b></span></li>
		 		<li><strong class="title fl">订单状态</strong><span class="fl red-font"><b>{{orderDetail.status}}</b></span></li>
		 	</ul> 
			<ul class="success-tips orgfont">
				<li>亲，谢谢您的订购!</li>
				<li>客服人员会在<b>一个工作日内</b>开通账号，并根据您填写的联系方式与您联系。</li>
				<li>如果您<b>急需使用</b>，请拨打客服电话:0755-82571522，138 0270 8576提醒客服人员尽快处理。</li>
			</ul>
		 </div>
	</div>
</template>

<script>

// import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'wxPay',
	// computed: {
	// 	...mapState({
	// 		isCollapse: (state) => state.isCollapse,
	// 	}),
	// 	...mapGetters(['isCollapse'])
	// },
	data() {
		return {
			orderDetail:{},
		}
	},
	beforeCreate() {

	},
	created() {

	},

	mounted() {
		this.getOrderDetail();
		document.title = '支付成功';

	},
	methods: {
		//定时获取订单详情，用来判断用户是否支付
		getOrderDetail() {
			var _this = this;
			var ajaxurl = this.$api.free.order.detail()+"?id="+this.$route.query.id;
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('订单详情', res);
					_this.orderDetail = res.data.data;
					// document.title = _this.orderDetail.isPay?'支付成功':'支付失败';
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.success-tips{
	float: right;;
	width: 594px;
    height: 300px;
	padding-right: 80px;
	// letter-spacing: 1px;
	line-height: 34px;
	font-size: 18px;
}
</style>
